export const CalendarConfig = {
    "default": {
        hide: true,
        showCalender: true,
        showPreset: false,
        isRequestDate: true,
        showDatetypeToggler: false,
        showDateTypeLabel: true,
        addAllPreset: false,
    },
    'account': {
        'home': {
            hide: true,
            showCalender: false,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: true,
            showDateTypeLabel: true,
            addAllPreset: false,
        },
        'scores': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
        },
        'inbox': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
            "all_responses": {
                hide: false,
                showCalender: true,
                showPreset: false,
                isRequestDate: false,
                showDatetypeToggler: true,
                showDateTypeLabel: true,
                addAllPreset: false,
            }
        },
        'engagement': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
        },
        'relationship':{
            hide: true,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
        }
    },
    'project': {
        'scores': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
            'quickinsights': {
                hide: false,
                showCalender: false,
                showPreset: true,
                isRequestDate: true,
                showDatetypeToggler: false,
                showDateTypeLabel: true,
                addAllPreset: false
            }
        },
        'inbox': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
            "customer_feedback": {
                hide: false,
                showCalender: true,
                showPreset: false,
                isRequestDate: false,
                showDatetypeToggler: true,
                showDateTypeLabel: true,
                addAllPreset: true,
            }
        },
         'sentiment-analysis': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: false,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
            "summary": {
                hide: false,
                showCalender: false,
                showPreset: true,
                isRequestDate: false,
                showDatetypeToggler: false,
                showDateTypeLabel: true,
                addAllPreset: false
            }
        },
        'outbox':{
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
        },
        'action': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: false,
            showDatetypeToggler: true,
            showDateTypeLabel: true,
            addAllPreset: false,
        },
        'engagement': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
        },
        'huddle': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: false,
            addAllPreset: false,
        },
        'sent': {
            hide: false,
            showCalender: true,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: false,
            showDateTypeLabel: true,
            addAllPreset: false,
        },
        'settings': {
            hide: true,
            showCalender: false,
            showPreset: false,
            isRequestDate: true,
            showDatetypeToggler: true,
            showDateTypeLabel: true,
            addAllPreset: false,
        }
    }
}